export default {
  list: [
    {
      title: 'بدهکار',
      value: 'DEBTOR'
    },
    {
      title: 'بستانکار',
      value: 'CREDITOR'
    },
    {
      title: 'صاف‌ شده',
      value: 'NOTHING'
    }
  ],
  values: {
    CREDITOR: 'CREDITOR',
    NOTHING: 'NOTHING',
    DEBTOR: 'DEBTOR'
  }
}